import {
  WSCard,
  WSElement,
  WSSectionToolbar,
  WSText,
  toWSDateString
} from "@wingspanhq/fe-component-library";
import { WorkLog } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { queriesPayPeriods, queriesPayrolls } from "@query";

type Props = {
  workLog?: WorkLog;
  shimmer?: boolean;
};

export const PayrollDetails: React.FC<Props> = props => {
  const payPeriodId = props.workLog?.payPeriodId ?? undefined;

  const queryPayPeriod = queriesPayPeriods.getPayPeriod.useQuery(
    { payPeriodId: payPeriodId! },
    { enabled: !!payPeriodId }
  );

  // v3 `listPayrolls` has no payPeriodId filter, so fetch the payer's payrolls
  // and match the one for this pay period client-side.
  // TODO(v3): add a payPeriodId filter to listPayrolls to drop the full fetch.
  const queryPayrolls = queriesPayrolls.listPayrolls.useQueryAll(undefined, {
    enabled: !!payPeriodId
  });

  if (props.shimmer) {
    return (
      <WSElement>
        <WSSectionToolbar title="Payroll details" />
        <WSCard shimmer />
      </WSElement>
    );
  }

  const payPeriod = queryPayPeriod.data;
  const payroll = payPeriodId
    ? (queryPayrolls.flatData ?? []).find(p => p.payPeriodId === payPeriodId)
    : undefined;

  const payPeriodText =
    payPeriod && payPeriod.startDate && payPeriod.endDate
      ? `${toWSDateString(payPeriod.startDate, "monthDayYear")} - ${toWSDateString(payPeriod.endDate, "monthDayYear")}`
      : undefined;

  return (
    <WSElement>
      <WSSectionToolbar title="Payroll details" />
      <WSCard>
        <WSElement>
          <WSText.ParagraphXs color="gray500">Pay period</WSText.ParagraphXs>
          <WSText.ParagraphSm color="gray700" mt="XS">
            {payPeriodText || "—"}
          </WSText.ParagraphSm>
        </WSElement>

        <WSElement mt="M">
          <WSText.ParagraphXs color="gray500">Payroll</WSText.ParagraphXs>
          {payroll ? (
            <WSText.ParagraphSm color="blue500" mt="XS" weight="medium">
              #{payroll.payrollNumber}
            </WSText.ParagraphSm>
          ) : (
            <WSText.ParagraphSm color="gray400" mt="XS">
              Not included in a payroll yet
            </WSText.ParagraphSm>
          )}
        </WSElement>

        <WSElement mt="M">
          <WSText.ParagraphXs color="gray500">Pay date</WSText.ParagraphXs>
          <WSText.ParagraphSm color="gray700" mt="XS">
            {payroll?.payDate
              ? toWSDateString(payroll.payDate, "monthDayYear")
              : "—"}
          </WSText.ParagraphSm>
        </WSElement>
      </WSCard>
    </WSElement>
  );
};
